module.exports = __webpack_public_path__ + "static/media/icon_permission.055af7a9.png";